export const headerQuery = `*[_type == 'header'] {
  menu,
  mobileMenu,
  headerButton
}[0]`